import { promo$, fetchPromo } from "@a365/api";

/**
 * Función para cargar promociones/banners
 * @param {string} country_id - ID del país
 */
export const loadPromo = (country_id) => {
  return fetchPromo(country_id);
};

// Función de compatibilidad con el código existente
export const getPromo = loadPromo;

// Re-exportar el observable para compatibilidad
export { promo$ };
